// react router
import { Link } from "react-router-dom";
// classnames
import ClassNames from "classnames";
// icons
import { CgFormatSlash } from "react-icons/cg";

const Breadcrumb = (props) => {
  // props
  const { crumbs, classNames } = props;

  // handlers
  const isLastCrumb = (crumbIndex) => {
    return crumbIndex === crumbs.length - 1;
  };

  return (
    <nav dir="rtl" className={classNames}>
      <ol className="flex items-center flex-wrap">
        {crumbs.map((crumb, index) => (
          <li key={index} className="flex items-center">
            <Link
              to={crumb.to}
              className={ClassNames("link", { disabled: isLastCrumb(index) })}
            >
              {crumb.name}
            </Link>
            {!isLastCrumb(index) && <CgFormatSlash />}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
